import { useCallback } from "react";
import { useSnackbarMutation } from "../../hooks";
import { BucketAttachment } from "../models";
import { MUTATIONS } from "../mutations";

type UseCouponsOpts = {
  onCouponUsageReportCreated?: (attachment: BucketAttachment) => void;
};

export function useCoupons(opts?: UseCouponsOpts) {
  const [
    invokeCreateCouponUsageReport,
    {
      loading: createCouponUsageReportLoading,
      error: createCouponUsageReportError,
    },
  ] = useSnackbarMutation(MUTATIONS.CREATE_COUPON_USAGE_REPORT, {
    onCompleted: (data) => {
      if (opts?.onCouponUsageReportCreated) {
        opts.onCouponUsageReportCreated(
          data.createCouponUsageReport as BucketAttachment
        );
      }
    },
  });

  const createCouponUsageReport = useCallback(
    (couponId: string) => {
      return invokeCreateCouponUsageReport({
        variables: {
          couponId,
        },
      });
    },
    [invokeCreateCouponUsageReport]
  );

  return {
    createCouponUsageReport,
    createCouponUsageReportError,
    createCouponUsageReportLoading,
  };
}
